import VeDelegateButtonWrapper from "~/modules/veDelegate/ButtonWrapper";

export default function VeDelegateWrapper() {
  return (
    <VeDelegateButtonWrapper appId="0x52239ee9403d804413a5dff852c4f6d6935ed8c0ee76634e9e54c5dcd46d8e47" />
  );
}